import type { AppConfig } from '@/types/config';

// Builds the public loyalty rewards API base URL from app config.
export const getRewardsApiUrlFromAppConfig = (config: AppConfig): string => {
    const loyalty = config.apis?.LoyaltyRewardsClient;
    if (!loyalty) {
        return '';
    }

    if (loyalty.baseUrl) {
        return loyalty.baseUrl.replace(/\/$/, '');
    }

    const protocol = loyalty.protocol ?? 'https';
    const host = loyalty.host ?? '';
    const pathPrefix = loyalty.pathPrefix ?? '';
    const combined = `${protocol}://${host}${pathPrefix}`;

    if (combined === 'https://' || combined === 'http://') {
        return combined;
    }

    return combined.replace(/\/$/, '');
};
